var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsuranceProcess2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.4531 100H6.83594C5.21797 100 3.90625 98.6883 3.90625 97.0703V14.0625C3.90625 6.3084 10.2146 0 17.9688 0H81.7383C82.923 0 83.9914 0.713672 84.4449 1.80859C84.8982 2.90332 84.6477 4.16348 83.8098 5.00137L67.3828 15.5689V97.0703C67.3828 98.6883 66.0711 100 64.4531 100Z",
    fill: "#E8F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M84.4475 1.80859C83.9939 0.713672 82.9256 0 81.7408 0H35.6797V100H64.4557C66.0736 100 67.3853 98.6883 67.3853 97.0703V15.5689L83.8123 5.00137C84.6502 4.16328 84.901 2.90332 84.4475 1.80859Z",
    fill: "#CEE2E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M55.6641 60.9375H27.3438C25.7258 60.9375 24.4141 59.6258 24.4141 58.0078C24.4141 56.3898 25.7258 55.0781 27.3438 55.0781H55.6641C57.282 55.0781 58.5938 56.3898 58.5938 58.0078C58.5938 59.6258 57.282 60.9375 55.6641 60.9375Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 60.9375C17.2387 60.9375 18.5547 59.6213 18.5547 58.0078C18.5547 56.3941 17.2385 55.0781 15.625 55.0781C14.0113 55.0781 12.6953 56.3941 12.6953 58.0078C12.6953 59.6213 14.0113 60.9375 15.625 60.9375Z",
    fill: "#00EED1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M55.6641 72.6562H27.3438C25.7258 72.6562 24.4141 71.3445 24.4141 69.7266C24.4141 68.1086 25.7258 66.7969 27.3438 66.7969H55.6641C57.282 66.7969 58.5938 68.1086 58.5938 69.7266C58.5938 71.3445 57.282 72.6562 55.6641 72.6562Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 72.6562C17.2387 72.6562 18.5547 71.34 18.5547 69.7266C18.5547 68.1129 17.2385 66.7969 15.625 66.7969C14.0113 66.7969 12.6953 68.1129 12.6953 69.7266C12.6953 71.3402 14.0113 72.6562 15.625 72.6562Z",
    fill: "#00EED1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M55.6641 84.375H27.3438C25.7258 84.375 24.4141 83.0633 24.4141 81.4453C24.4141 79.8273 25.7258 78.5156 27.3438 78.5156H55.6641C57.282 78.5156 58.5938 79.8273 58.5938 81.4453C58.5938 83.0633 57.282 84.375 55.6641 84.375Z",
    fill: "#0095FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 84.375C17.2387 84.375 18.5547 83.059 18.5547 81.4453C18.5547 79.8316 17.2385 78.5156 15.625 78.5156C14.0113 78.5156 12.6953 79.8316 12.6953 81.4453C12.6953 83.059 14.0113 84.375 15.625 84.375Z",
    fill: "#00EED1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M35.6754 41.7357C28.432 41.7357 22.5391 35.8428 22.5391 28.5992C22.5391 21.3559 28.432 15.4629 35.6754 15.4629C42.9189 15.4629 48.8117 21.3559 48.8117 28.5992C48.8117 35.8428 42.9188 41.7357 35.6754 41.7357Z",
    fill: "#00EED1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M35.6797 15.4629V41.7357C42.9232 41.7357 48.816 35.8428 48.816 28.5992C48.816 21.3557 42.923 15.4629 35.6797 15.4629Z",
    fill: "#00CCB3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M35.6698 34.8534C34.8927 34.8534 34.1476 34.5448 33.5981 33.9952L29.9206 30.3177C28.7765 29.1735 28.7765 27.3187 29.9206 26.1745C31.0647 25.0304 32.9196 25.0304 34.0638 26.1745L35.6696 27.7806L48.6978 14.7526C49.8419 13.6085 51.697 13.6085 52.8409 14.7526C53.9851 15.8966 53.9851 17.7517 52.8409 18.8958L37.7413 33.9954C37.1919 34.5448 36.4468 34.8534 35.6698 34.8534Z",
    fill: "#212CBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M93.1641 54.1012H70.3125C68.6945 54.1012 67.3828 52.7894 67.3828 51.1715V14.3555C67.3828 6.43984 73.8227 0 81.7383 0C89.6539 0 96.0938 6.43984 96.0938 14.3555V51.1715C96.0938 52.7894 94.782 54.1012 93.1641 54.1012Z",
    fill: "#00215A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M52.8445 14.7526C51.7008 13.6085 49.8457 13.6085 48.7014 14.7526L35.6797 27.7741V34.853C36.4543 34.8513 37.1969 34.5433 37.7449 33.9952L52.8445 18.8956C53.9889 17.7519 53.9889 15.8968 52.8445 14.7526Z",
    fill: "#00215A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M55.6666 55.0781H35.6797V60.9375H55.6666C57.2846 60.9375 58.5963 59.6258 58.5963 58.0078C58.5963 56.3898 57.2846 55.0781 55.6666 55.0781Z",
    fill: "#0063E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M55.6666 66.7969H35.6797V72.6562H55.6666C57.2846 72.6562 58.5963 71.3445 58.5963 69.7266C58.5963 68.1086 57.2846 66.7969 55.6666 66.7969Z",
    fill: "#0063E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M55.6666 78.5156H35.6797V84.375H55.6666C57.2846 84.375 58.5963 83.0633 58.5963 81.4453C58.5963 79.8273 57.2846 78.5156 55.6666 78.5156Z",
    fill: "#0063E5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceProcess2);
export default __webpack_public_path__ + "static/media/insurance_process2.0afd88d922286c4e8263bf7d870d5830.svg";
export { ForwardRef as ReactComponent };